export const PATHS = {
  dashboard: '/dashboard',
  test: '/test',
  profile: '/profile',
  subscription: '/subscription',
  subscriptionSuccess: '/subscription/success',
  subscriptionCancel: '/subscription/cancel',
  contactUs: '/contact-us',
  login: '/login',
  register: '/register',
  verifyEmail: '/verify-email',
  welcome: '/welcome',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  googleCallback: '/google-callback',
  viewImage: '/view-image',
  documentAnalysis: {
    root: '/document-analysis',
    cv: '/document-analysis/cv',
    cvDetail: '/document-analysis/cv/:id',
    coverLetter: '/document-analysis/cover-letter',
    coverLetterDetail: '/document-analysis/cover-letter/:id',
    history: '/document-analysis/history',
  },
  documentGeneration: {
    root: '/document-generation',
    coverLetter: '/document-generation/cover-letter',
    history: '/document-generation/history',
  },
  interviewSimulation: {
    root: '/interview-simulation',
    start: '/interview-simulation/start',
    session: '/interview-simulation/session',
    history: '/interview-simulation/history',
    analysis: '/interview-simulation/analysis/:id',
  },
} as const;
